import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DistributorRepMapperState } from 'types';

export const initialState: DistributorRepMapperState = {
  loading: false,
  distributorRepMapperList: [],
  countryCode:"us",
  reset: false,
  filter:null
};

const slice = createSlice({
  name: 'DistributorRepMapper',
  initialState,
  reducers: {
    setDistributorRepMapperList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.reset = false;
      state.distributorRepMapperList = payload || [];
    },
    reset: (state) => {
      state.reset = true
    },
    setCountry: (state, { payload }: PayloadAction<any>) => {
      state.countryCode = payload;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = payload;
    },
  }
});

export const { setDistributorRepMapperList,setCountry, setFilter, reset } = slice.actions;

export default slice.reducer;
